import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../config/axios';
import { AuthContext } from '../context/AuthContext';
import { formatError } from '../utils/errorHandler';
import './SupportBanner.css';

const SupportBanner = () => {
  const { t } = useTranslation('common');
  const { user, fetchUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);
  const [error, setError] = useState('');

  if (!user?.supportingCompany) {
    return null;
  }

  const handleExit = async () => {
    setExiting(true);
    setError('');
    try {
      await axios.post('/api/companies/support/exit');
      await fetchUser();
      navigate('/super-admin');
    } catch (exitError) {
      setError(formatError(exitError) || t('supportExitFailed'));
    } finally {
      setExiting(false);
    }
  };

  return (
    <div className="support-banner" role="status">
      <div className="support-banner-content">
        <span className="material-symbols-outlined support-banner-icon" aria-hidden="true">
          support_agent
        </span>
        <div className="support-banner-text">
          <strong>{t('supportBannerTitle', { company: user.supportingCompany.name })}</strong>
          {error && <p className="support-banner-error">{error}</p>}
        </div>
        <button
          type="button"
          className="btn btn-secondary btn-sm support-banner-exit"
          onClick={handleExit}
          disabled={exiting}
        >
          {exiting ? t('supportExiting') : t('supportExitCta')}
        </button>
      </div>
    </div>
  );
};

export default SupportBanner;
